import { ErrorHandler, inject, Injectable } from "@angular/core";
import { LoggerService } from "@shared/services/logger/logger.service";

@Injectable()
// Global error handler provider for capturing uncaught runtime exceptions.
// Logs error details, stack traces, and user session context to the logging service.
export class GlobalErrorHandler implements ErrorHandler {
    private readonly logger: LoggerService = inject(LoggerService);

    // The handleError method is called whenever an uncaught error occurs in the application.
    // It logs the error message and stack trace using the LoggerService, along with the user's email from session storage.
    handleError(error: Error): void {
        const errorMessage: string = error.message ? error.message : error.toString();
        const stackTrace: string = error.stack ? error.stack : "No stack trace available";

        console.error(error);
        this.logger.error("User: " + sessionStorage.getItem("email") + ", " + errorMessage, stackTrace);
    }
}
